import { call, put, takeEvery } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { createNewAdvertisement } from "./helpers/createItems";
import { addItemToListAndFractal } from "./helpers/updateOrderListAndFractal";
import { advertisementsItemOrderSelector, advertisementsOrderSelector } from "./helpers";
import { push } from "connected-react-router";


function* addItem({payload}) {
    const newAdvertisement = yield call(createNewAdvertisement, payload.itemData)

    if(!newAdvertisement) {
        return yield false
    }

    yield call(addItemToListAndFractal, newAdvertisement.payload.pk, actionTypes.ADVERTISEMENTS_UPDATE_ORDER, actionTypes.ADVERTISEMENTS_UPDATE_ITEM_ORDER, advertisementsOrderSelector, advertisementsItemOrderSelector)

    if(payload.closePagePath)  {
        yield put(push(payload.closePagePath))
    }
   
}

export function* watchAddAdvertisement() {
    try {
        yield takeEvery(actionTypes.ADVERTISEMENTS_REQUEST_ADD_ITEM, addItem)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}